<template>
  <div class="search">
    <div class="ziHeadtit wrap">
      <span>
        <span style="padding-left: 25px">您所在的位置：</span>
        <router-link to="/">
          <span>首页</span>
        </router-link>
        <span>&nbsp;>&nbsp;搜索</span>
      </span>
    </div>
    <div
      class="width_100"
      id="Nav"
    ></div>
    <!-- <div class="wrap headersearch">
      <el-input
        v-model="searchValue"
        placeholder="请输入搜索关键词"
      ></el-input>
      <el-button
        type="submit"
        @click="searchSubmit"
        >搜索</el-button
      >
    </div> -->
    <div class="main_panel wrap">
      <div class="navPage">
        <div id="PageRight">
          <!-- <div class="Nav">
            <a
              href="/"
              target="_blank"
              ><i class="iconfont">&#xe689; </i></a
            >
            &nbsp;&nbsp;&nbsp;&nbsp;搜索关键词：{{ searchValue | ellipsis }}
            &nbsp;&nbsp;&nbsp;&nbsp;搜索结果
          </div> -->
          <div id="NewsList">
            <ul class="comUl">
              <li
                v-for="(item, index) in searchList"
                :key="index"
              >
                <a
                  v-if="item.url && item.url !== ''"
                  :href="item.url"
                  target="_blank"
                >
                  <div class="searchTime">
                    <p>{{ dayjs(item.publishDate).format("YYYY-MM-DD") }}</p>
                  </div>
                  <div class="searchTxt">
                    <p>{{ item.title | ellipsis }}</p>
                  </div>
                </a>
                <a
                  v-else-if="
                    (!item.url || item.url == '') &&
                    item.entTChannelUuid == '00190001'
                  "
                  target="_blank"
                  :href="`/detail/00280002/${item.entTArticleUuid}`"
                >
                  <div class="searchTime">
                    <p>{{ dayjs(item.publishDate).format("YYYY-MM-DD") }}</p>
                  </div>
                  <div class="searchTxt">
                    <p>{{ item.title | ellipsis }}</p>
                  </div>
                </a>
                <a
                  v-else
                  :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                  target="_blank"
                >
                  <div class="searchTime">
                    <p>{{ dayjs(item.publishDate).format("YYYY-MM-DD") }}</p>
                  </div>
                  <div class="searchTxt">
                    <p>{{ item.title | ellipsis }}</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="pagin"
        v-if="searchList.length > 0"
      >
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          :pager-count="6"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { articleSearch } from "@/api/common";
export default {
  data() {
    return {
      searchValue: "",
      pageSize: 12,
      pageNum: 1,
      total: 0,
      searchList: [],
    };
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function (value) {
      if (!value) return "";
      if (value.length > 48) {
        return value.slice(0, 48) + "...";
      }
      return value;
    },
  },
  mounted() {
    var _this = this;
    _this.searchValue = _this.$route.params.title
    _this.articles();
  },
  methods: {
    searchSubmit() {
      var _this = this;
      if (!_this.searchValue || _this.searchValue == "") {
        this.$message({
          message: "请输入关键词进行搜索！",
          type: "warning",
          offset: 200,
        });
      } else {
        window.location.href = `/search/${_this.searchValue}`
        // _this.articles();
      }
    },
    // 获取列表
    articles() {
      var _this = this;
      let data = {
        // title: _this.$route.params.title,
        title: _this.searchValue,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize,
        entTApplicationUuid: _this.webId,
      };
      articleSearch(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.searchList = data.rows;
          _this.total = data.totalRows;
        }
      });
    },
    currentChange(e) {
      var _this = this;
      _this.pageNum = e;
      _this.articles();
    },
  },
};
</script>
<style>
@font-face {
  font-family: "iconfont"; /* Project id 3165120 */
  src: url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.woff2?t=1644917438066")
      format("woff2"),
    url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.woff?t=1644917438066")
      format("woff"),
    url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.ttf?t=1644917438066")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 22px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.1px;
  -moz-osx-font-smoothing: grayscale;
}
.search {
  position: relative;
  min-height: calc(100vh - 504px);
}
.ziHeadtit {
  width: 1400px;
  margin-top: 10px;
  background: url(../assets/img/mappoint.png) no-repeat;
}
.ziHeadtit span {
  font-size: 16px;
}
.search .headersearch {
  float: none;
  margin: 30px auto;
}
.search .headersearch div {
  width: calc(100% - 52px);
  height: 70px;
  font-size: 14px;
  box-shadow: 0 0 10px #ccc;
}
.search .headersearch input {
  overflow: hidden;
  height: 70px;
  line-height: 70px;
  color: #585858;
  border-radius: 0px;
  border: solid 1px #0d65af;
}
.search .headersearch button {
  height: 70px;
  line-height: 70px;
  padding: 0px 12px;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  border: none;
  cursor: pointer;
  /* vertical-align: top; */
  width: 52px;
  background-color: #0d65af;
  border-radius: 0px;
}
.search .headersearch .el-button:hover {
  color: black;
  background-color: rgb(13, 101, 175);
}
.search .headersearch .el-button:focus {
  color: rgb(255, 255, 255);
  border-color: #c6e2ff;
  background-color: rgb(54, 154, 236);
}
.search #Nav {
  position: absolute;
  height: 44px;
  z-index: -1;
  background-color: #f2f2f2;
}
.search #Nav {
  float: right;
  text-align: right;
  overflow: hidden;
  line-height: 40px;
  color: #636363;
  font-size: 14px;
}
.search .width_100 {
  width: 100% !important;
}
.search .main_panel {
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.navPage {
  display: block;
}
.search #PageLeft {
  width: 255px;
  float: left;
  overflow: hidden;
  margin-top: 3px;
  margin-right: 35px;
}
.search #PageLeft .Tit {
  width: 255px;
  height: 105px;
  color: #fff;
  z-index: 9999999;
  background: #0062b3 35px no-repeat;
  margin-bottom: 2px;
}
.search #PageLeft .Tit .word {
  width: 155px;
  height: 105px;
  line-height: 105px;
  font-size: 26px;
  float: left;
  margin-left: 95px;
}
.search #PageLeft .sort {
  width: 100%;
  overflow: hidden;
}
.search #PageRight {
  width: 100%;
  overflow: hidden;
}
.search #PageRight .Nav {
  width: 100%;
  height: 44px;
  line-height: 44px;
  overflow: hidden;
  color: #888888;
  margin-bottom: 10px;
}
.search #PageRight .Nav a {
  color: #888888;
}
.search .comUl {
  padding-left: 0;
}
.search .comUl li {
  width: 100%;
  height: 60px;
  line-height: 60px;
  margin: 0px auto;
  /* padding: 10px 0; */
  border-bottom: 1px dashed #e5e5e5;
}
.search .comUl li a {
  height: 100%;
  white-space: nowrap;
  display: block;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  color: #000;
  background-color: #fff;
  font-family: "PingFangSC-Light", "Microsoft JhengHei", "微软雅黑", sans-serif, verdana, arial;
}
.searchTime {
  width: 130px;
  height: 100%;
  float: right;
  color: #323232;
  text-align: center;
}
.searchTime p {
  /* padding: 35px 0 10px 0px; */
  font-size: 16px;
  height: 60px;
  color: #999;
}
.searchTxt {
  width: calc(100% - 161px);
  height: 60px;
  float: left;
  /* margin-top: 30px; */
  background: url(../assets/img/listpoint.jpg) no-repeat left center;
  padding-left: 10px;
}
.searchTxt p:nth-child(1) {
  line-height: 60px;
  height: 60px;
  font-size: 16px;
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
/* .search .comUl li a:hover .searchTime {
  background-color: #0062b3;
  transition: all 0.5s ease-in-out;
  color: #fff;
} */
.search .comUl li a:hover .searchTxt p:nth-child(1){
  transition: all 0.3s ease-in-out;
  color: #0062b3;
}
.search .pagin {
  margin-top: 20px;
  margin-bottom: 23px;
  padding: 20px;
}
.search .pagin .el-pagination {
  text-align: center;
}
@media (max-width: 1400px) {
  .search #PageRight {
    width: 95%;
  }
  .ziHeadtit {
    left: 80px;
  }
}
@media (max-width: 992px) {
  .search #PageLeft {
    display: none;
  }
  .search {
    margin-top: auto;
  }
  .ziHeadtit {
    top: 85px;
    left: 30px;
  }
}
@media (max-width: 768px) {
  .search #PageLeft {
    display: none;
  }
  .search {
    margin-top: auto;
  }
}
</style>
